// extracted by mini-css-extract-plugin
export default {"alreadyHaveAnAccount":"X8KVT0","link":"B2iK5l"};